import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

interface UnsupportedBrowserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const UnsupportedBrowserDialog = ({ open, onOpenChange }: UnsupportedBrowserDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noCloseBtn className="w-[360px] p-[30px]">
        <div className="flex flex-col items-start">
          <div className="text-gr-900 Title3S18">현재 브라우저에서는 이용할 수 없어요</div>
          <div className="mt-[4px] text-gr-700 Body5M14">
            해당 확장프로그램은 크롬 브라우저에서만 지원돼요.
            <br />
            크롬으로 접속하시면 서비스를 이용하실 수 있어요.
          </div>
          <div className="mt-[20px] flex w-full">
            <Button
              variant="muted"
              className="h-[48px] flex-1"
              onClick={() => onOpenChange(false)}
            >
              확인
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UnsupportedBrowserDialog;
